import React from "react";
import { Routes, Route } from "react-router-dom";

import Invoices from "./invoices";
import List from "./list";
import Recouvrement from "./recouvrement";
import View from "./view";

const Cashout = () => {
  return (
    <Routes>
      <Route path="/" element={<Invoices />} />
      <Route path="/classic" element={<List />} />
      <Route path="/recouvrement" element={<Recouvrement />} />
      <Route path="/:id/*" element={<View />} />
    </Routes>
  );
};

export default Cashout;
